window.addEventListener('scroll', ()=>{
  const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

  if(scrollTop > window.innerHeight * 0.5){
    document.body.classList.add('scrolled');
  }else{
    document.body.classList.remove('scrolled');
  }

  const mainHeader = document.querySelector('body > header');
  if(mainHeader){
    if(scrollTop > mainHeader.getBoundingClientRect().height){
      document.body.classList.add('scroll-over-header');
    }else{
      document.body.classList.remove('scroll-over-header');
    }
  }
});


function setupNavMenu(){
//open navigation menu
  const menuToggle = document.getElementById('nav-menu-toggle');
//  const menu = document.getElementById('nav-menu');
  const menuClose = document.getElementById('nav-menu-close');

  if(menuToggle){
    const open = () =>{
      document.body.classList.add('modal-open', 'nav-menu-open');
    }

    const close = () => {
      document.body.classList.add('nav-menu-closing');
      setTimeout(()=>{
        document.body.classList.remove('nav-menu-closing');
      }, 2000);

      document.body.classList.remove('modal-open', 'nav-menu-open');
      document.body.style.paddingRight = "";
    }

    if(menuClose){
      menuClose.addEventListener('click', ev => {
        ev.preventDefault();
        ev.stopPropagation();
        close();
      })
    }

    menuToggle.addEventListener('click', ev =>{
      ev.preventDefault();
      ev.stopPropagation();
      document.body.classList.contains('nav-menu-open') ? close() : open();
    })

    document.querySelectorAll('.menu-parent').forEach(it=>{
      it.addEventListener('click', ()=>{
        if(it.classList.contains('expand')){
          it.classList.remove('expand');          
          return;
        }
        document.querySelectorAll('.menu-parent').forEach(it =>{
          it.classList.remove('expand');
        });
        it.classList.add('expand');
      })
    })
  }
}

(fn => (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn))(()=>{
  setupNavMenu();
})

class Toast{
  static iid = 0;

  static show(message){
    const view = document.getElementById('toast');
    
    clearTimeout(this.iid);
    // add new tag
    const newNode = document.createElement('div');
    newNode.appendChild(document.createTextNode(message));
    view.appendChild(newNode);

    //show message,
    view.classList.add('toast-is-show');
    this.iid = setTimeout(() => this.hide(), 3000);
  }

  //visually hide the toast.
  static hide(){
    const view = document.getElementById('toast');

    clearTimeout(this.iid);

    view.classList.remove('toast-is-show');
    this.iid = setTimeout(() => this.remove(), 1000);
  }

  //remove content
  static remove(){
    const view = document.getElementById('toast');
    while(view.firstChild){
      view.removeChild(view.firstChild);
    }
  }
}